module.exports = __webpack_public_path__ + "static/media/trashcan.092d25c4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/trashcan.svg
// module id = 1504
// module chunks = 49